import { useCallback, useState } from "react";
import Modal from "../../../../common/components/Modal";
import { Button, Stack } from "~/common/mui";
import {
  makeOnFilterChange,
  type NotificationFilterEntry,
  NotificationsFilters
} from "~/features/notifications/NotificationsPage/components/NotificationsFilters";
import { useTranslation } from "react-i18next";

interface NotificationsFiltersProps {
  currentFilters: NotificationFilterEntry[];
  onClose: () => void;
  onApply: (newFilters: NotificationFilterEntry[]) => void;
}

export const NotificationsFiltersModal = ({ currentFilters, onClose, onApply }: NotificationsFiltersProps) => {
  const { t } = useTranslation();

  const [filters, setFilters] = useState(currentFilters);

  const clearAllCb = () => {
    onClose();
  };
  const applyCb = () => {
    onClose();
    onApply(filters);
  };

  const onFilterChange = useCallback(makeOnFilterChange(setFilters), []);

  return (
    <Modal
      onClose={onClose}
      title={t("notificationsPage.filters.title")}
      footerChildren={
        <Stack gap={1} direction={"row"}>
          <Button variant={"text"} onClick={clearAllCb} data-test-id={"confirmation-modal-cancel"}>
            {t("cancel")}
          </Button>
          <Button onClick={applyCb} data-test-id={"confirmation-modal-ok"}>
            {t("searchPage.showResults")}
          </Button>
        </Stack>
      }
    >
      <NotificationsFilters filters={filters} onFilterChange={onFilterChange} />
    </Modal>
  );
};
